"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_SHOW_ANI_COLUMNS_MAP = void 0;
exports.SORTABLE_SHOW_ANI_COLUMNS_MAP = {
    ani: 'did_ani',
    fecha_asignacion: 'did_fecha_creacion',
    fecha_modificacion: 'did_fecha_mod',
    estado: 'did_estado',
};
